import {
  alertMessagesArgsConfig,
  collectionArgsConfig,
  collectionFieldArgsConfig,
  getItemIdFromArgsConfig,
} from '../../utils/event_constants';

export const qrActions = [
  {
    name: 'generateQR',
    label: 'Generate QR Code',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'dataField', label: 'Select Data Field' }),
      ...getItemIdFromArgsConfig,
      {
        name: 'codeType',
        label: 'Select Code Type to Generate.',
        type: 'dropdown',
        optionsType: 'codeTypeApi',
        options: [
          { label: 'QR Code', value: 'qr' },
          { label: 'Bar Code', value: 'bar' },
        ],
        value: '',
      },
      collectionFieldArgsConfig({ name: 'saveQRField', label: 'Select Field to Save QR' }),
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'initiateQRCodeReader',
    label: 'Initiate QR Code Reader',
    args: [...alertMessagesArgsConfig],
  },
];
